import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  SelectChangeEvent,
  Typography,
} from "@mui/material";
import { closeIcon, saveIcon } from "assets/images";
import { useEffect, useState } from "react";
import { UpdateSLPParticipationPayload } from "store/slpDashboard/type";
import { SLP_PARTICIPATION } from "utils/constants/slp";
import { SLPParticipation } from "utils/enums/slp";
import { showLoader } from "utils/helper";
import { IUpdateSLPParticipationValue } from "utils/interfaces/slp";

export type ISLPParticipationModalProps = {
  onClose: () => void;
  slpParticipationDetail: IUpdateSLPParticipationValue;
  updateSLPParticipationRequest: (payload: UpdateSLPParticipationPayload) => {};
  onSaveCallback: () => void;
};

const SLPParticipationModal = ({
  onClose,
  slpParticipationDetail,
  updateSLPParticipationRequest,
  onSaveCallback,
}: ISLPParticipationModalProps) => {
  const [selectedParticipation, setSelectedParticipation] =
    useState<SLPParticipation>(SLPParticipation.Active);

  useEffect(() => {
    setSelectedParticipation(slpParticipationDetail.slpParticipation);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleParticipationChange = (
    event: SelectChangeEvent<SLPParticipation>
  ) => {
    setSelectedParticipation(event.target.value as SLPParticipation);
  };

  const handleSaveClick = () => {
    if (updateSLPParticipationRequest) {
      showLoader();
      updateSLPParticipationRequest({
        value: {
          studentId: slpParticipationDetail.studentId,
          slpParticipation: selectedParticipation,
        },
        callback: onSaveCallback,
      });
    }
  };

  return (
    <Modal open onClose={onClose}>
      <Box className="common-modal modal-400">
        <Box className="modal-header">
          <Typography variant="h4">SLP Participation</Typography>
          <IconButton onClick={onClose}>
            <img src={closeIcon} alt="close" />
          </IconButton>
        </Box>
        <Box className="modal-body">
          <Grid container columnSpacing="16px">
            <Grid item xs>
              <FormControl fullWidth className="select">
                <InputLabel id="course1-label">Status</InputLabel>
                <Select
                  labelId="slp-participation-label"
                  label="Status"
                  value={selectedParticipation}
                  onChange={handleParticipationChange}
                >
                  {SLP_PARTICIPATION.map((participation) => (
                    <MenuItem
                      key={participation.value}
                      value={participation.value}
                    >
                      {participation.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Box>
        <Box className="modal-footer">
          <Button
            variant="contained"
            className="btn-save"
            onClick={handleSaveClick}
          >
            <img src={saveIcon} alt="save" />
            Save
          </Button>
          <Button variant="outlined" className="btn-cancel" onClick={onClose}>
            Cancel
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default SLPParticipationModal;
